import { render, staticRenderFns } from "./IrregularTimetableDetailsView.vue?vue&type=template&id=20afe773&scoped=true"
import script from "./IrregularTimetableDetailsView.vue?vue&type=script&lang=js"
export * from "./IrregularTimetableDetailsView.vue?vue&type=script&lang=js"
import style0 from "./IrregularTimetableDetailsView.vue?vue&type=style&index=0&id=20afe773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20afe773",
  null
  
)

export default component.exports